const config = {
    baseUrl: {
        $default: 'http://localhost:3000',
        staging: 'https://dev-trademark.spyamz.com',
        production: 'https://trademark.spyamz.com',
    },
    baseAPIUrl: {
        $default: 'http://localhost:7123',
        staging: 'https://dev-trademark-services.spyamz.com',
        production: 'https://trademark-services.spyamz.com',
    },
};

const _getEnvironment = () => {
    return process.env.REACT_APP_ENV || 'development';
};

export default (key, defaultValue = null) => {
    if (!config.hasOwnProperty(key)) {
        return defaultValue;
    }

    const env = _getEnvironment();
    const _dataConfig = config[key];

    return _dataConfig[env] ? _dataConfig[env] : _dataConfig['$default'] || defaultValue;
};


// WEBPACK FOOTER //
// ./src/helpers/common/getEnv.js